import { useEffect, useState } from "react";
import { Star, Quote } from "lucide-react";

const TESTIMONIALS = [
  { name: "David P.", company: "Eagle Farm Logistics", quote: "Forkfix had our LPG unit back up and running within the same day. Their mobile service saved us a full afternoon of downtime.", role: "Warehouse Manager" },
  { name: "Sarah T.", company: "Bulimba Distribution Co.", quote: "Reliable, honest and fair pricing. We've moved our whole 6-forklift fleet across to Forkfix for scheduled maintenance.", role: "Operations Lead" },
  { name: "Mick R.", company: "Rocklea Cold Storage", quote: "Called at 6:30am with a hydraulic leak — technician was on site by 9. Professional job and a proper written report after.", role: "Site Supervisor" },
  { name: "Linda H.", company: "Ipswich Industrial Supplies", quote: "Bought a used Toyota through Forkfix and it's been faultless. Genuine advice, no upselling. Highly recommend.", role: "Owner" },
  { name: "James K.", company: "Acacia Ridge Freight", quote: "Their safety inspection picked up a mast fault we hadn't noticed. Saved us a potential incident. Won't use anyone else.", role: "OHS Coordinator" },
];

const ROTATE_MS = 6000;

export default function Testimonials() {
  const [i, setI] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setI(x => (x + 1) % TESTIMONIALS.length), ROTATE_MS);
    return () => clearInterval(t);
  }, []);

  const active = TESTIMONIALS[i];

  return (
    <section className="bg-white py-16 md:py-24 border-t border-[#e5e5e5]">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <div className="text-xs uppercase tracking-widest text-[#D71920] font-bold">Client feedback</div>
        <h2 className="font-display text-4xl md:text-5xl uppercase mt-2">What Brisbane businesses say</h2>

        <div className="mt-12 relative min-h-[240px]" data-testid="testimonials-carousel">
          <Quote className="w-16 h-16 text-[#D71920]/10 mx-auto" />
          <blockquote key={active.name} className="mt-2 animate-fadein" data-testid={`testimonial-${i}`}>
            <p className="font-display text-2xl md:text-3xl leading-snug text-[#111]">"{active.quote}"</p>
            <div className="mt-6 flex items-center justify-center gap-1 text-[#D71920]">
              {["s1","s2","s3","s4","s5"].map(id => <Star key={`${active.name}-${id}`} className="w-4 h-4 fill-current" />)}
            </div>
            <footer className="mt-4">
              <div className="font-display text-lg uppercase">{active.name}</div>
              <div className="text-xs uppercase tracking-widest text-[#666]">{active.role} · {active.company}</div>
            </footer>
          </blockquote>
        </div>

        <div className="flex justify-center gap-2 mt-8">
          {TESTIMONIALS.map((t, k) => (
            <button key={t.name} onClick={() => setI(k)}
              aria-label={`Show testimonial ${k + 1}`}
              className={`w-10 h-1 transition ${k === i ? "bg-[#D71920]" : "bg-[#e5e5e5] hover:bg-[#999]"}`}
              data-testid={`testimonial-dot-${k}`} />
          ))}
        </div>
      </div>
    </section>
  );
}
